<div class="change-password">
<header>
  <div class="customer-language-picker-area">
    <div class="picker-label">
      <label class="switch">
        <input
          type="checkbox"
          (change)="useLang($event.target.checked ? 'en' : 'da')"
          [checked]="currentLang === 'en'"
          />
        <span class="slider round">
          <span class="lang lang-da">Dansk</span>
          <span class="slider-color"></span>
          <span class="lang lang-en">English</span>
        </span>
      </label>
    </div>
  </div>
</header>

<section class="change-password__body">
  <div class="change-password__center">
    <div class="change-password__panel">
      <div class="change-password__panel-header">
      <a class="change-password__logo" routerLink="/">
        <img
          src="assets/images/Pitten.svg"
          alt="PITTEN"
          height="30"
          />
      </a>
    </div>
    </div>
    <div class="change-password__panel-body">

    @if (!showConfirmation) {
        <p class="change-password__title">
          {{ "menu.changePassword" | translate }}
        </p>
        <p class="change-password__subtitle">
          {{ "changePassword.changePasswordSubtitle" | translate }}
        </p>

      <form
        [formGroup]="changePasswordForm"
        class="change-password__form"
        (ngSubmit)="onSubmit()"
        >
        <input
          type="password"
          class="change-password__input"
                    [placeholder]="
                        'changePassword.passwordPlaceholder' | translate
                    "
          formControlName="password"
          />
        <input
          type="password"
          class="change-password__input"
                    [placeholder]="
                        'changePassword.confirmPasswordPlaceholder' | translate
                    "
          formControlName="passwordConfirm"
          />

        <div class="login-page__action mb-3">
          <app-input-button>{{
            "changePassword.changePasswordButton" | translate }}
          </app-input-button>
        </div>
      </form>
    } @else {
      <div class="change-password__confirmation">
        <p class="change-password__title">
          {{ "changePassword.passwordChangedTitle" | translate }}
        </p>
        <p class="change-password__subtitle">
          {{ "changePassword.passwordChangedSubtitle" | translate }}
          <a routerLink="/">{{ "changePassword.here" | translate }}</a
            >.
          </p>
        </div>
      }
    </div>
    </div>
  </section>
</div>